var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"callAction",style:(_vm.styleSection)},[_c('div',{staticClass:"container__full"},[_c('div',{staticClass:"grid grid__1--1"},[_c('div',{staticClass:"grid__item--pd pd__left--col"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }